import { Badge, BadgeProps } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';

import Text from 'components/shared/Text';
import { LeadStatus as LeadStatusType, leadStatusColorMap, leadStatusTextMap } from 'entities/Lead';

import s from './LeadStatus.module.scss';

type LeadStatusProps = Omit<BadgeProps, 'color' | 'variant' | 'children'> & {
  className?: string;
  status: LeadStatusType;
};

const LeadStatus: React.FC<LeadStatusProps> = ({ className, status, size = 'lg', ...props }) => {
  return (
    <Badge
      className={cn(s.root, className)}
      color={leadStatusColorMap[status]}
      size={size}
      variant="light"
      mih={leadStatusTextMap[status].tag.split('\n').length * 30}
      {...props}
    >
      <Text size="xs" className={s.root__label} component="span">
        {leadStatusTextMap[status].tag}
      </Text>
    </Badge>
  );
};

export default React.memo(LeadStatus);
